import { FaReact, FaHtml5 } from "react-icons/fa";
import { RiNextjsLine } from "react-icons/ri";

const icons = {
  react: FaReact,
  nextjs: RiNextjsLine,
  html: FaHtml5,
};

const TechIcon = ({ tech }) => {
  const Icon = icons[tech] || FaReact;
  return <Icon />;
};

export default TechIcon;
